<p-dialog [(visible)]="visible" [modal]="true" [style]="{width:'420px'}" [header]="title">
  <p>{{ message }}</p>
  <ng-template pTemplate="footer">
    <button class="ecb-btn-outline" (click)="cancel.emit()">Cancel</button>
    <button class="ecb-btn-primary" (click)="confirm.emit()">Confirm</button>
  </ng-template>
</p-dialog>
